import type { ReactNode } from 'react';

interface Props {
  title: string;
  code?: string;
  status?: 'live' | 'loading' | 'error' | 'idle' | 'stale';
  meta?: string;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  actions?: ReactNode;
}

export function HudFrame({
  title,
  code,
  status = 'idle',
  meta,
  children,
  className = '',
  bodyClassName = '',
  actions,
}: Props) {
  return (
    <section className={`hud ${className}`}>
      <div className="hud__corners" aria-hidden>
        <span className="hud__c hud__c--tl" />
        <span className="hud__c hud__c--tr" />
        <span className="hud__c hud__c--bl" />
        <span className="hud__c hud__c--br" />
      </div>
      <header className="hud__head">
        <div className="hud__title-row">
          <span className={`hud__led hud__led--${status}`} />
          <h2 className="hud__title">{title}</h2>
          {code && <span className="hud__code">{code}</span>}
        </div>
        <div className="hud__head-right">
          {meta && <span className="hud__meta">{meta}</span>}
          {actions}
        </div>
      </header>
      <div className={`hud__body ${bodyClassName}`}>{children}</div>
    </section>
  );
}
